import { createSelector } from '@reduxjs/toolkit';
import { sortBy } from 'lodash/fp';
import { type RootState } from '@/store';

export const sports = ({ sports: { sports } }: RootState) => sports;

export const orderedSports = createSelector(sports, (sports) =>
  sports?.length ? sortBy('id', sports) : undefined,
);
